module.exports = __webpack_public_path__ + "assets/img/transparent-filler.8bf37bfa.png";